<h1 mat-dialog-title>Route wählen</h1>
<div mat-dialog-content>
    <mat-form-field style="margin-top: 24px; width: 100%">
        <mat-label>Route</mat-label>
        <input type="text" placeholder="Route" matInput [formControl]="searchCtrl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="navigate($event)">
            @for (option of filteredOptions | async; track option) {
            <mat-option [value]="option">
                {{ option.displayName }}
            </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-flat-button (click)="this.dialogRef.close()">Schließen</button>
</div>